module.exports = __webpack_public_path__ + "media/images/profile/info-a6e69f97ea6f90d404b278e2580b2c7f.svg";